<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="colors"
    :search="search"
    sort-by="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>CORES</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="colors.length == 0"
          :href="linkExcel"
          target="_blank"
          color="grey darken-4"
          outlined
          small
          class="mt-3 float-right"
        >
          <v-icon color="green" left> mdi-file-excel-box </v-icon>
          Excel
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import { URL } from "@/api/config";
import * as API from "@/api/requests/ColorRequest";

export default {
  data: () => ({
    search: "",
    loading: false,
    headers: [
      { text: "Código", value: "code", width: 100 },
      { text: "Nome", value: "name", width: 350 },
    ],
    colors: [],
    lazy: false,
    valid: true,
  }),
  computed: {
    linkExcel() {
      return `${URL}report/report-color`;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getColors();
    },
    validate() {},
    async getColors() {
      this.loading = true;
      this.colors = [];
      try {
        this.colors = await API.getAll();
        this.colors = this.colors.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table {
  overflow-x: auto;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
